export default __webpack_public_path__ + "static/media/futures_binance.20ad95ac.svg";